import { render, staticRenderFns } from "./ClientEditEmails.vue?vue&type=template&id=f7529134"
import script from "./ClientEditEmails.vue?vue&type=script&lang=js"
export * from "./ClientEditEmails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports